export const trackCta = (cta) => {
  // Best effort and never block the referral navigation, even offline.
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/cta`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify({ event_id: crypto.randomUUID(), cta }),
    }).catch(() => {});
  } catch { /* Referral navigation must remain usable. */ }
};